var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.$t("actions.actionDefinition.model.configurationJson.dutyId")
            )
          )
        ]),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            options: _vm.duties,
            label: "title",
            reduce: t => t.dutyId,
            clearable: false
          },
          model: {
            value: _vm.dutyId,
            callback: function($$v) {
              _vm.dutyId = $$v
            },
            expression: "dutyId"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }